var $7819440e0c7e25c3$exports = {};
$7819440e0c7e25c3$exports = {
    "maximum": `\u{6700}\u{5927}`,
    "minimum": `\u{6700}\u{5C0F}`
};


export {$7819440e0c7e25c3$exports as default};
//# sourceMappingURL=zh-CN.mjs.map
